import { IUser } from './authentication.client';
import httpClient from './http-client';

export type JobStatus = 'pending' | 'completed' | 'failed' | 'running';

type JobTypes =
  | 'user_availability'
  | 'user_unavailability'
  | 'case_crawler'
  | 'statement'
  | 'customer_commercial_report';

export type JobOperationTypes =
  | 'crawler_case_artifacts'
  | 'crawler_case_report_inspections'
  | 'crawler_sinister_documents'
  | 'crawler_expert_examinations'
  | 'crawler_claims'
  | 'customer_commercial_report';

export interface IJobProgress {
  operation: JobOperationTypes;
  doneAt: Date;
}

// Sync state of a case_crawler job as the backend judges it: `stalled` is a
// job that stopped moving, which unlocks the resync button.
export type CaseSyncState =
  | 'queued'
  | 'syncing'
  | 'stalled'
  | 'completed'
  | 'failed';

// `bulk` is the queue of automatic Triage imports.
export type CaseSyncLane = 'priority' | 'bulk';

export interface IJob {
  completedAt: string;
  startedAt: string;
  progress: IJobProgress[];
  id: number;
  type: JobTypes;
  schedule?: string;
  executeAt?: string;
  failedReason?: string;
  status: JobStatus;
  createdBy: IUser;
  metadata: object;
  // Only on case_crawler jobs of the case detail.
  syncState?: CaseSyncState;
  syncLane?: CaseSyncLane;
}

export class JobClient {
  static async createUnavailabilityJob(data: { from: string; to: string }) {
    const response = await httpClient.post('/v1/job/unavailability', data);

    return response.data;
  }

  static async createOwnUnavailabilityJob(data: { from: string; to: string }) {
    const response = await httpClient.post('/v1/job/unavailability/own', data);

    return response.data;
  }

  static async delete(jobId: number) {
    const response = await httpClient.delete(`/v1/job/${jobId}`);

    return response.data;
  }

  static async listPending(cookie?: string): Promise<{ jobs: IJob[] }> {
    const response = await httpClient.get('/v1/job/pending', {
      headers: {
        Cookie: cookie,
      },
    });

    return response.data;
  }

  static async cancelUnavailabilityJob(jobId: number) {
    const response = await httpClient.delete(`/v1/job/unavailability/${jobId}`);

    return response.data;
  }
}
